import React, {useRef} from 'react'
import {usePanier} from '../pages/Televendeur/PanierContext'
import {checkDispoPieceLocal, deletePieceInProposee} from '../../../../components/requests'
import {toast} from 'react-toastify'

type AddToPanierButtonProps = {
  state: any
  piece: any
  detailVehicle?: {
    marque: string | undefined
    modele: string | undefined
    // dateMiseCirc: string | undefined
  }
  isDetailPiece: boolean
  isListPieceStock: boolean
  tauxRemise: number
  prixTransport: number
  idTypePiece: number
  idClientDemandePiece: number
  quantityPiece: number
  setPieceToValidate: any
  pieceToValidate: any
}

const AddToPanierButton = ({
  piece,
  isDetailPiece,
  isListPieceStock,
  setPieceToValidate,
}: AddToPanierButtonProps) => {
  const {panier, setPanier} = usePanier()
  const isInPanier = panier.some((item: any) => item.id === piece?.id)
  const openModalProvenance = useRef<HTMLButtonElement>(null)

  // Vérification disponibilité de la pièce
  const handlePanier = async () => {
    const existing = panier.find((item: any) => item.id === piece.id)

    if (existing) {
      const idToast = toast.loading('Suppression en cours...')
      try {
        await deletePieceInProposee(existing.idPiecePropose)
        toast.update(idToast, {
          render: 'Pièce retirée du panier !',
          type: 'success',
          isLoading: false,
          autoClose: 2000,
        })
        setPanier((prev) => prev.filter((item) => item.id !== piece.id))
      } catch (e) {
        console.error(e)
        toast.update(idToast, {
          render: 'Erreur lors de la suppression',
          type: 'error',
          isLoading: false,
          autoClose: 2000,
        })
      }
    } else {
      // Vérifie si la pièce est déjà présente dans le panier
      const existInPanier = panier.some((item: any) => item.id === piece.id)

      let isAvailable = {data: {Trouvée: false, Dispo: false, Erreur: null}}
      if (!existInPanier) {
        const idToastCheckPieces = toast.loading('Vérification en cours...')
        let message
        let action
        try {
          // Vérifie si la pièce est dispo sur atemo ou non
          // isAvailable = await checkDispoPiece(piece.code)
          isAvailable = await checkDispoPieceLocal(piece.code)
          if (isAvailable?.data?.Trouvée && isAvailable?.data?.Dispo) {
            setPieceToValidate(piece)
            openModalProvenance.current?.click()
            message = 'Pièce disponible !'
            action = 'success'
          } else if (isAvailable?.data?.Trouvée && !isAvailable?.data?.Dispo) {
            message = 'Pièce vendue !'
            action = 'error'
          } else if (isAvailable?.data?.Erreur) {
            message = 'Erreur lors de la vérification !'
            action = 'error'
          } else {
            message = 'Pièce introuvable !'
            action = 'error'
          }
        } catch (e) {
          // Une erreur s'est produit durant la vérification de la pièce
          console.error('Error')
          message = "Une erreur s'est produite lors de la vérification de la pièce"
          action = 'error'
        }
        toast.update(idToastCheckPieces, {
          render: message,
          type: action,
          isLoading: false,
          autoClose: 2000,
        })
      }
    }
  }

  return (
    <>
      {/*Bouton via liste piece en stock*/}
      {isListPieceStock && (
        <>
          {(() => {
            // Vérifie si la pièce est déjà proposée, soit dans la source, soit dans le panier
            const isAlreadyProposed =
              piece?.isProposed === true ||
              panier.some((p: any) => p.id === piece.id && p.isProposed === true)
            // N'affiche PAS le bouton si la pièce est déjà proposée
            if (isAlreadyProposed) return null

            return (
              <span className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                <img
                  src={
                    isInPanier
                      ? '/media/svg/custom/bag-minus.svg'
                      : '/media/svg/custom/bag-plus.svg'
                  }
                  style={{cursor: 'pointer'}}
                  data-tooltip-id='tooltip'
                  data-tooltip-content={isInPanier ? 'Retirer du panier' : 'Ajouter au panier'}
                  data-tooltip-place='right'
                  alt={isInPanier ? 'delete from shop' : 'add to shop'}
                  width={20}
                  onClick={(e) => {
                    e.stopPropagation()
                    handlePanier()
                  }}
                />
              </span>
            )
          })()}
        </>
      )}

      {/*Bouton  modal détail pièce*/}
      {isDetailPiece && (
        <>
          {(() => {
            const isAlreadyProposed =
              piece?.isProposed === true ||
              (piece?.pieceProposee?.length > 0 && piece?.pieceProposee[0]?.isProposed === true) ||
              panier.some((p: any) => p?.id === piece?.id && p.isProposed === true)

            if (isAlreadyProposed) return null

            return (
              <button
                type='button'
                className={isInPanier ? 'btn btn-danger' : 'btn btn-primary'}
                onClick={() => handlePanier()}
              >
                {isInPanier ? 'Retirer du panier' : 'Ajouter au panier'}
              </button>
            )
          })()}
        </>
      )}

      {/*Bouton déclenchement du modal de provenance*/}
      <button
        className={'d-none'}
        ref={openModalProvenance}
        data-bs-target='#kt_modal_provenance'
        data-bs-toggle='modal'
        data-bs-dismiss='modal'
      ></button>
    </>
  )
}

export default AddToPanierButton
